<template>
    <div class="popup--overlay" v-if="show">
        <a href="#" @click.prevent="close" class="popup--window--close-full"></a>
        <div class="popup--window">
            <a href="#" @click.prevent="close" class="popup--window--close-btn">
                <svg class="popup--icon-end" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.526 32.526"><path d="M32.526 2.828L29.698 0 16.263 13.435 2.828 0 0 2.828l13.435 13.435L0 29.698l2.828 2.828L16.263 19.09l13.435 13.435 2.828-2.828L19.09 16.263z"/></svg>
            </a>
            <div class="popup--window--inner">
                <div>
                    <h3 class="popup--headline">Upravit</h3>
                    <div class="form--wrapper" @keydown.enter="handleUpdateSubmit">
                        <div class="form--input--wrapper">
                            <label for="description" class="popup--label">Popisek</label>
                            <textarea v-model="forms.updateForm.description" id="description" class="popup--input"></textarea>
                        </div>
                        <div class="form--input--wrapper">
                            <input type="submit" value="Uložit" @click="handleUpdateSubmit" class="popup--button">
                        </div>
                    </div>
                </div>

                <div>
                    <h3 class="popup--headline">Přístup a nájemnici</h3>
                    <div class="form--wrapper" @keydown.enter="handleUpdateSubmit">
                        <div class="form--input--wrapper">
                            <label for="invite_form_email" class="popup--label">Email</label>
                            <input v-model="forms.inviteForm.email" type="email" id="invite_form_email" class="popup--input">
                        </div>
                        <div class="form--input--wrapper">
                            <label for="invite_form_firstName" class="popup--label">Jméno</label>
                            <input v-model="forms.inviteForm.firstName" type="text" id="invite_form_firstName" class="popup--input">
                        </div>
                        <div class="form--input--wrapper">
                            <label for="invite_form_lastName" class="popup--label">Příjmení</label>
                            <input v-model="forms.inviteForm.lastName" type="text" id="invite_form_lastName" class="popup--input">
                        </div>
                        <div class="form--input--wrapper">
                            <input type="submit" value="Pozvat" @click="handleInviteSubmit" class="popup--button">
                        </div>
                    </div>
                </div>

                <div v-if="!structureDetail" class="text-center">
                    Načítám
                </div>

                <div v-if="structureDetail && structureDetail.invitations.length > 0">
                    <h3 class="popup--headline">Aktuální nevyzvednuté pozvánky</h3>
                    <div v-for="invitation of structureDetail.invitations" class="table-custom">
                        <div class="table-custom--wrap">{{invitation.firstName}} {{invitation.lastName}}</div>
                        <div class="table-custom--wrap">{{invitation.email}}</div>
                    </div>

<!--                    <table>-->
<!--                        <tr>-->
<!--                            <th>Email</th>-->
<!--                            <th>Jméno</th>-->
<!--                            <th>Příjmení</th>-->
<!--                        </tr>-->
<!--                        <tr v-for="invitation of structureDetail.invitations">-->
<!--                            <th>{{invitation.email}}</th>-->
<!--                            <th>{{invitation.firstName}}</th>-->
<!--                            <th>{{invitation.lastName}}</th>-->
<!--                        </tr>-->
<!--                    </table>-->
                </div>

                <div v-if="structureDetail && structureDetail.accesses.length > 0">
                    <h3 class="popup--headline">Aktuální přístupy</h3>

                    <div v-for="access of structureDetail.accesses" class="table-custom">
                        <div class="table-custom--wrap">
                            <div class="table-custom--item">
                                {{access.user.firstName}} {{access.user.lastName}}
                            </div>
                            <div class="table-custom--item">
                                {{access.user.contactEmail}}
                            </div>
                        </div>
                        <div class="table-custom--wrap">
                            <div class="table-custom--item">
                                {{access.start|moment("DoMM. YYYY")}}
                                -
                                <span v-if="access.expire">{{access.expire|moment("DoMM. YYYY")}}</span>
                                <span v-if="!access.expire">Nikdy</span>
                            </div>
                            <div class="table-custom--item">
                                <button class="table-custom--button" v-if="access.valid" @click="block(access.id)">Zablokovat</button>
                            </div>
                        </div>
                    </div>

<!--                    <table>-->
<!--                        <tr>-->
<!--                            <th>Email</th>-->
<!--&lt;!&ndash;                          HERMI  zatim jsem to skryl. ale pak to tam dame HERMI &ndash;&gt;-->
<!--                            <th>Jméno</th>-->
<!--                            <th>Příjmení</th>-->
<!--                            <th>Přidáno</th>-->
<!--                            <th>Expiruje</th>-->
<!--                            <th>Akce</th>-->
<!--                        </tr>-->
<!--                        <tr v-for="access of structureDetail.accesses">-->
<!--                            <th>{{access.user.contactEmail}}</th>-->
<!--                            <th>{{access.user.firstName}}</th>-->
<!--                            <th>{{access.user.lastName}}</th>-->
<!--                            <th>{{access.start|moment("DoMM. YYYY")}}</th>-->
<!--                            <th v-if="access.expire">{{access.expire|moment("DoMM. YYYY")}}</th>-->
<!--                            <th v-if="!access.expire">Nikdy</th>-->
<!--                            <th v-if="access.valid"><button @click="block(access.id)">Zablokovat</button></th>-->
<!--                            <th v-if="!access.valid">-</th>-->
<!--                        </tr>-->
<!--                    </table>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { postInviteToStructure } from '../../api/structure';
  import { disableStructureAccess } from '../../api/structureAccess';

  export default {
    name: "UpdateDescriptionPopup",
    data: function () {
      return {
        show: false,
        data: null,
        forms: {
          updateForm: {
            description: '',
          },
          inviteForm: {
            email: '',
            firstName: '',
            lastName: ''
          }
        },

        currentStructure: null
      };
    },
    computed: {
        structureDetail: function () {
          return this.$store.getters['structure/structureDetailById'](this.data.structureId);
        }
    },
    methods: {
      updateDetails: function(){
        this.$store.dispatch('structure/getStructureDetails', {structureId: this.data.structureId});
      },
      open: function (data) {
        this.show = true;
        this.data = data;

        this.$store.dispatch('structure/getStructureDetails', {structureId: this.data.structureId});
        this.currentStructure = this.$store.getters['structure/dashboardStructureById'](this.data.structureId);

        this.forms.updateForm.description = this.currentStructure.adminDescription;
      },
      close: function () {
        this.show = false;
      },
      handleUpdateSubmit: async function () {
        try {
          await this.$store.dispatch('structure/updateStructure', {
            structureId: this.data.structureId,
            data: {
              description: this.forms.updateForm.description
            }
          });

          this.$toasted.show('Uloženo.',{type: 'success'});
        } catch (e) {
            console.log(e);
        }
      },
      handleInviteSubmit: async function () {
        try {
          const accessToken = this.$store.state.user.authTokens.accessToken;
          const response = await postInviteToStructure(accessToken, this.data.structureId, this.forms.inviteForm);

          this.forms.inviteForm.email = '';
          this.forms.inviteForm.firstName = '';
          this.forms.inviteForm.lastName = '';

          this.$toasted.show('Pozvánka odeslaná.',{type: 'success'});
          this.updateDetails();
        } catch (e) {

        }
      },
      block: async function(id) {
        const accessToken = this.$store.state.user.authTokens.accessToken;
        const response = await disableStructureAccess(accessToken, id);

        this.$toasted.show('Přístup odebraný.',{type: 'success'});
        this.updateDetails();
      }
    }
  }
</script>

<style scoped lang="less">
    .form {
        &--wrapper {
            &--input {
                width: 100%;
            }
        }
    }
    .text-center{
        text-align: center;
    }
    .table-custom {
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 10px;
        margin: 0 -5px 10px;
        border-bottom: 1px solid #e4e5ea;
        &:first-of-type {
            padding-top: 5px;
        }
        &:last-child {
            border: none;
        }
        &--wrap {
            flex: 0 0 50%;
            padding: 5px;
        }
        &--item {
            display: flex;
            align-items: center;
            min-height: 35px;
        }
        &--button {
            background: #e91e63;
            color: white;
            border: solid 1px #e91e63;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 5px 20px;
        }
    }
</style>
